import type { FC } from 'react';
import { Gallery, Play } from '@elfsight/icons';

export type BaseMediaType = 'image' | 'link' | 'gallery' | 'video' | 'audio';

type MediaTypesRecord = Record<
  BaseMediaType,
  {
    title: string;
    icon?: FC;
  }
>;

export const mediaTypes: MediaTypesRecord = {
  audio: {
    title: 'Audio'
  },
  image: {
    title: 'Image'
  },
  link: {
    title: 'Share'
  },
  gallery: {
    title: 'Gallery',
    icon: Gallery
  },
  video: {
    title: 'Video',
    icon: Play
  }
};
